// custom CSS styles
import "./src/css/style.css"
import "./src/css/transitions.css"

import React from "react"
import { Script } from "gatsby"

export const wrapPageElement = ({ element }) => {
  return (
    <>
      {element}
      <Script
        key="adobe-pdf-sdk"
        src="https://documentcloud.adobe.com/view-sdk/viewer.js"
        async
      />
    </>
  )
}
